import Button from '@jetbrains/ring-ui/components/button/button'
import Dialog from '@jetbrains/ring-ui/components/dialog/dialog'
import {Content, Header} from '@jetbrains/ring-ui/components/island/island'
import Panel from '@jetbrains/ring-ui/components/panel/panel'
import * as React from 'react'

import Markdown from '../../../common/Markdown/Markdown'
import {LinkOpenPolicy} from '../../../common/Markdown/Markdown.consts'

import type {HealthItemDialogProps} from './HealthItem.types'

import styles from './HealthItem.css'

function HealthItemDialog({
  category,
  identity,
  show,
  close,
  healthItemElement,
  hidePersonal,
  hideGlobal,
  markdown,
}: HealthItemDialogProps) {
  const contentRef = React.useRef<HTMLDivElement>(null)
  const portal = React.useMemo(
    () => document.querySelector(`[data-health-report-popup-portal='${identity}']`),
    [identity],
  )
  const onClose = React.useCallback(() => close(), [close])
  React.useEffect(() => {
    if (contentRef.current == null || healthItemElement == null) {
      return
    }

    if (show) {
      contentRef.current.appendChild(healthItemElement)
    }
  }, [healthItemElement, identity, show])

  const title = category.name ? `${category.name}` : 'Health item report'
  return (
    <Dialog
      label={title}
      trapFocus
      portalTarget={portal}
      contentClassName={styles.dialog}
      showCloseButton
      onCloseAttempt={onClose}
      show={show}
    >
      <Header>{title}</Header>
      <Content className={styles.contentPanel}>
        {markdown && (
          <Markdown className={styles.markdown} linkOpenPolicy={LinkOpenPolicy.ALL_IN_NEW_TAB}>
            {markdown}
          </Markdown>
        )}
        <div ref={contentRef} />
      </Content>
      <Panel>
        <Button onClick={onClose}>{'Close'}</Button>
        {hidePersonal && <Button onClick={hidePersonal}>{'Hide for me'}</Button>}
        {hideGlobal && <Button onClick={hideGlobal}>{'Hide for everyone'}</Button>}
      </Panel>
    </Dialog>
  )
}

export default HealthItemDialog
